import React from "react";
import msCertifiedApp from "../../assets/svg/mscertifiedapp.svg";
import { Trans, useTranslation } from "../../plugins/i18next/ea-react-i18next";
import BookDemoButton from "../Start/BookDemoButton";
import "./FeaturesSection.module.css";
import { FeatureProps, ProductFeatureList } from "./ProductList";
import Button, { ButtonType } from "../Start/Button";

export function Feature({
  title,
  Svg,
  description,
  link,
  basicsLink,
  features,
  customActionButtonText,
  isSecondaryButton,
  backgroundColor,
  isProduct,
  isLandingPage,
  msCertifiedLink,
  hideDemoButton
}: FeatureProps) {
  const { t } = useTranslation("components", { keyPrefix: 'products.productCards' });
  const isLandingPageProduct = isProduct && isLandingPage;

  return (
    <div className={`single-featured-services-item product mb-0`} style={{ backgroundColor: backgroundColor ?? "" }}>
      <div className="product-header pb-60">
        {Svg ? <img src={Svg} alt={t(title)} className="productlogo" /> : <h4>{(<Trans t={t}>{title}</Trans>)}</h4>}
        {msCertifiedLink && (
          <a href={msCertifiedLink} target="_blank"><img id="mscertified" src={msCertifiedApp} alt="Microsoft 365 Certified App" className="productcertified" /></a>
        )}
      </div>
      <div className="product-content">
        <p>{description && (<Trans t={t}>{description}</Trans>)}</p>
        {isLandingPage && features?.length && (
          <ul>
            {features.map((feature, idx) => (
              <li key={idx}>{t(feature)}</li>
            ))}
          </ul>
        )}
      </div>
      {isLandingPage == false && (<div className="product-footer">
        {basicsLink && (
          <Button href={basicsLink} text={t("learnMore")} icon="learn-caret" type={ButtonType.Tertiary}/>
        )}
        {!isSecondaryButton
          ? <>
            {customActionButtonText ? (
              <Button external={true} icon="flaticon-right" text={t(customActionButtonText as string)} href={link as string} />
            ) : (
              hideDemoButton == false ? (<BookDemoButton />) : <></>
            )}
          </>
          : <>
            <Button text={customActionButtonText as string} href={link} />
          </>
        }
      </div>)}
      {isLandingPageProduct == true ?
        (<div className="product-footer">
          <div className="hero-banner-footer">
            <Button text={t("learnMore")} href={basicsLink} type={ButtonType.Tertiary} />
          </div>
        </div>) : <>
          {isLandingPage && (<div className="product-footer">
            <div className="hero-banner-footer">
              <Button href={link} text={t(customActionButtonText as string)} icon="learn-caret" type={ButtonType.Tertiary}/>
            </div>
          </div>)}
        </>
      }

    </div>
  )
}

const ProductCards: React.FC<{ product: string, isLandingPage: boolean }> = ({ product, isLandingPage }) => {
  const productFeatures = ProductFeatureList.filter(
    productItem => productItem.type !== product
  )

  const { t } = useTranslation("components");

  return (
    <React.Fragment>
      <div className="container-fluid hero-container">
        <div className='solutions-container'>
          <div className='subscribe-content'>
            <h2>{t("products.productCards.solutions")}</h2>
          </div>
          <div className='our-solutions'>
            {productFeatures.map((props, idx) => (
              <Feature key={idx} {...props} isLandingPage={isLandingPage} />
            ))}
          </div>
        </div>
      </div>
    </React.Fragment >
  )
}

export default ProductCards
